import React from 'react';
import { Column } from 'devextreme-react/data-grid';
import { GroupItem, SimpleItem } from "devextreme-react/form";
import GestionAbstract from '../../components/forms/gestion-abstract';
import ILangue from "../../models/ILangue";
import Guid from '../../models/Guid';
import IBaseModel from '../../models/IBaseModel';

interface IGestionLanguesProps {
  isModeSelection?: boolean,
}

class Langue extends IBaseModel implements ILangue {
  idLangue: Guid = Guid.empty;
  code: string = '';
}

export default function GestionLangues({ isModeSelection }: IGestionLanguesProps) {
  return (
    <GestionAbstract<ILangue>
      isModeSelection={isModeSelection}
      path="langue"
      primaryKey="idLangue"
      model={Langue}
      additionalColumns={
        <>
          <Column key={"grid-col-code"} dataField={"code"} caption="Code" allowHiding={false} />
          <Column key={"grid-col-description"} dataField={"description"} caption="Description" allowHiding={false} />
        </>
      }
      customFormItems={() => (
        <GroupItem>
          <SimpleItem key={"frm-code"} dataField={'code'} />
          <SimpleItem key={"frm-description"} dataField={'description'} />
        </GroupItem>
      )}
    />
  );
}
